import lb from '@/lib/loopback';

export function findNotificacoes(settings = {}) {
  return lb
    .find('/Notificacoes/', settings);
}

export function updateNotificacao(notificacao) {
  return lb.patch(`/Notificacoes/${notificacao.id}`, notificacao);
}

export function createNotificacao(notificacao) {
  return lb.post('/Notificacoes/', notificacao);
}

export default {
  findNotificacoes,
  updateNotificacao,
  createNotificacao,
};
